import { useEffect } from "react"
import { Editor as ToastUiEditor } from "@toast-ui/react-editor"
import { moveFocusToNextElement } from "@/modules/patients/libs/move-focus-to-next-element"

export const useEditorKeyDown = (ref: React.RefObject<ToastUiEditor | null>, isEditorVisible?: boolean) => {
  useEffect(() => {
    if (!isEditorVisible) return

    const rootElement = ref.current?.getRootElement?.()
    if (!rootElement) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === "Enter") {
        e.preventDefault()
        moveFocusToNextElement(document.activeElement as HTMLElement)
      }
    }

    rootElement.addEventListener("keydown", handleKeyDown)
  }, [ref, isEditorVisible])
}
